module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("This site is a work in progress.")]), _vm._v(" "), _c('p', [_vm._v("As such, I'll be working on design and functionality throughout the process of making the comic.")]), _vm._v(" "), _c('p', [_vm._v("Known Issues")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("No way to mark comments as spam or report them (for now, just email erty)")]), _vm._v(" "), _c('li', [_vm._v("I want to eventually allow users to login with Facebook")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebd7e9e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToDo.vue
// module id = 285
// module chunks = 1